import { RootState } from '../../../rootReducer';

export const mainPageSelector = (state: RootState) => state.mainModuleReducer.UserReducer;
